import CryptoJS from "crypto-js";
import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AppCtrl from "../control/AppCtrl";
import useAlert from "../hook/useAlert";
import useCookie from "../hook/useCookie";
import useAtgGames from "../redux/atgGames/atgGamesAction";
import useBetWin from "../redux/betWinData/betWinAction";
import useBoosting from "../redux/boosting/boostingAction";
import useBroadcasts from "../redux/broadcasts/broadcastsAction";
import useGameplay from "../redux/gameplay/gameplayAction";
import useGuoZhao from "../redux/guoZhao/guoZhaoAction";
import useLobbies from "../redux/lobbies/lobbiesAction";
import useLobbyMachines from "../redux/lobbyMachines/lobbyMachinesAction";
import useRsgGames from "../redux/rsgGames/rsgGamesAction";
import useScoreMsg from "../redux/scoreMsg/scoreMsgAction";
import switchFunc from "../redux/switchFunc/switchFuncAction";
import switchPage from "../redux/switchPage/switchPageAction";
import useUserCoins from "../redux/userCoins/userCoinsAction";
import Config from "../utils/Config";
import EPage from "../utils/EPage";
import EFunction from "../utils/FunctionPage";
import LANGUAGE_TYPE from "../utils/Language";
import Utils from "../utils/Utils";
import AtgGame from "./AtgGame";
import AtgLobby from "./AtgLobby";
import GamePlayClassic from "./GamePlayPage/Classic";
import GameSpyClassic from "./GameSpyPage/Classic";
import LobbyPage from "./LobbyPage";
import MainPage from "./MainPage";
import ReloadPage from "./ReloadPage";
import RsgGame from "./RsgGame";
import RsgLobby from "./RsgLobby";

function App() {
  //const navigate = useNavigate();

  const { page, setPage } = switchPage();
  const { setFunc } = switchFunc();
  const { setLobbies } = useLobbies();
  const { setUserCoins } = useUserCoins();
  const { setBroadcasts, setBonusBroadcast } = useBroadcasts();
  const { setScoreMsg } = useScoreMsg();
  const { setLobbyMachines } = useLobbyMachines();
  const { setGameplay } = useGameplay();
  const { setBetWinData, setBonusState } = useBetWin();
  const { setBoosting } = useBoosting();
  const { setGuoZhao } = useGuoZhao();
  const { setAtgGames, setAtgGameUrl } = useAtgGames();
  const { setRsgGames, setRsgGameUrl } = useRsgGames();
  const topUpRef = useRef(null);
  const { setCookie, getCookie, delCookie } = useCookie();
  const { showAlert } = useAlert();

  const navigate = useNavigate();
  let macAddress = [];
  let gmAccount = null;
  let palyerAccount = null;
  let playerPassword = null;
  let playerKeyInScore1 = 0;
  let playerKeyInScore2 = 0;
  let playerKeyOutScore = 100;
  const SECRET_KEY = "Kelly99527$";
  let hLoginTimeout = null;
  //===========================================================================
  useEffect(() => {
    componentDidMount();
    return componentWillUnmount;
  }, []);

  // useEffect(() => {
  //     switch (page) {
  //         case EPage.main: navigate('/main'); break;
  //         case EPage.lobby: navigate('/lobby'); break;
  //         case EPage.playClassic: navigate('/playClassic'); break;
  //         case EPage.playBJ: navigate('/playBJ'); break;
  //         case EPage.spyClassic: navigate('/spyClassic'); break;
  //         case EPage.reload: navigate('/reload'); break;
  //     }
  // }, [page]);
  //===========================================================================

  function componentDidMount() {
    // const code = `(function () {
    //     function sleep(milliseconds) {
    //         const currentTime = new Date().getTime();

    //         let i = 0;
    //         while (currentTime + milliseconds >= new Date().getTime()) {
    //             i++;
    //             if(i % 1000000 === 0){
    //                 console.log('rows processed : ' + i);
    //             }
    //         }
    //     }

    //     self.onmessage = function (event){
    //         console.log(event.data);

    //         sleep(1000);

    //         self.postMessage('!!!long task completed!!!');
    //         self.close();
    //     }
    // })();`;
    // const createBlobObjectURL = (code) => {
    //     const blob = new Blob([`${code}`], { type: "text/javascript" });
    //     const url = URL.createObjectURL(blob);
    //     return url;
    // };
    // const worker = new Worker(createBlobObjectURL(code));
    // worker.onmessage = function (event) {
    //     console.log(event.data)
    // }
    // worker.postMessage('long task started');

    // replace bg image

    if (Config?.urlBGImageHome) {
      if (Utils.isGifByExtension(Config.urlBGImageHome)) {
        document.body.style.backgroundImage = `url('${Config.urlBGImageHome}')`;
        document.body.style.backgroundSize = "auto 100%";
        document.body.style.backgroundRepeat = "no-repeat";
        document.body.style.backgroundPosition = "center center";
      } else {
        document.body.style.backgroundImage = `url('${Config.urlBGImageHome}')`;
        document.body.style.backgroundSize = "100% 100%";
      }
    } else if (Config?.urlBGImage) {
      if (Utils.isGifByExtension(Config.urlBGImage)) {
        document.body.style.backgroundImage = `url('${Config.urlBGImage}')`;
        document.body.style.backgroundSize = "auto 100%";
        document.body.style.backgroundRepeat = "no-repeat";
        document.body.style.backgroundPosition = "center center";
      } else {
        document.body.style.backgroundImage = `url('${Config.urlBGImage}')`;
        document.body.style.backgroundSize = "100% 100%";
      }
    }

    AppCtrl.assignApp({
      onPage,
      onUserCoins,
      onGuoZhao,
      onScoreMsg,
      onLobbyInfos,
      onLobbyMachines,
      onBroadcastMsgs,
      onBonusBroadcast,
      onGameplay,
      onBetWinData,
      onBonusState,
      onBoosting,
      onAtgGames,
      onAtgGameUrl,
      onRsgGames,
      onRsgGameUrl,
    });

    const url = new URL(window.location.href);
    const agent = url.searchParams.get("agent");
    const token = url.searchParams.get("token");
    console.log(`agent:${agent}, token:${token}`);

    const apiUrl = "APIs/DB/VerifyUser.ashx";
    const apiData = {
      AgentId: agent,
      Token: token,
      ConnectionId: null,
    };
    Utils.postAPI(apiUrl, apiData)
      .then(function (response) {
        if (response.status == "success") {
          throw new Error("prelogin is not ready");
        } else {
          throw new Error(response.message);
        }
      })
      .catch(function (err) {
        console.log(err);
        AppCtrl.switchPage(EPage.main);
        // navigate('/login');
        setFunc(EFunction.login);
      });

    window.addEventListener("message", (event) => {
      if (
        event.origin !== "http://localhost:5173" &&
        event.origin !== "http://localhost:3001"
      ) {
        console.log("來自未授權來源的訊息，已忽略:", event.origin);
        return;
      }

      if (macAddress.length > 0 && !macAddress.includes(event.data.mac)) {
        console.log("macAddress is not matched");
        return;
      }

      // 確保 event.data 存在並且是物件
      if (!event.data || typeof event.data !== "object") {
        console.log("收到不正確的訊息格式:", event.data);
        return;
      }

      // 根據 type 來處理不同的訊息類型
      switch (event.data.type) {
        case "REQUEST_LOAD_DATA":
          //macAddress = event.data.mac;
          const bytes = CryptoJS.AES.decrypt(
            event.data.accountData,
            SECRET_KEY
          );
          const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
          let srcWin = event.source;
          AppCtrl.setSourceWin(srcWin);
          AppCtrl.setOriginDomain(event.origin);
          if (!decryptedData) {
            //throw new Error("解密失敗");
            console.error("解密失敗");
            sourceWin.postMessage(
              { type: "RESPONSE_LOAD_DATA", Result: "FAIL" },
              AppCtrl.getOriginDomain()
            );
            return;
          }
          console.log("使用者登入成功:", decryptedData);
          let data = JSON.parse(decryptedData);
          //回傳資料物件給送訊息的來源response
          //{ type: "REQUEST_BILL_ACCEPTOR", bill: billAmount , mac: macAddress},
          //console.log("解密成功:", decryptedData);
          if (Array.isArray(data.Mac)) {
            // 是陣列，逐一加入
            data.Mac.forEach((mac) => {
              macAddress.push(mac);
            });
          } else {
            // 不是陣列，直接加入後轉成陣列
            macAddress.push(data.Mac);
          }
          //macAddress = data.Mac;
          gmAccount = data.GM;
          palyerAccount = data.Account;
          playerPassword = data.Password;
          if (data.keyInScore1) playerKeyInScore1 = data.keyInScore1;
          if (data.keyInScore2) playerKeyInScore2 = data.keyInScore2;
          if (data.keyOutScore) playerKeyOutScore = data.keyOutScore;
          //if (macAddress.length > 0 && !macAddress.includes(event.data.mac))
          if (!macAddress.includes(event.data.mac)) {
            AppCtrl.getSourceWin().postMessage(
              {
                type: "RESPONSE_LOAD_DATA",
                Player: palyerAccount,
                Result: "FAIL",
              },
              AppCtrl.getOriginDomain()
            );
          } else {
            AppCtrl.getSourceWin().postMessage(
              {
                type: "RESPONSE_LOAD_DATA",
                Player: palyerAccount,
                Result: "SUCCESS",
              },
              AppCtrl.getOriginDomain()
            );
          }

          if (gmAccount && palyerAccount && playerPassword) {
            AppCtrl.connectToServer(null, function () {
              AppCtrl.requestConfig();
              //send request token
              AppCtrl.requestLoginToken(
                palyerAccount,
                playerPassword,
                true,
                onLoginResponseFromMachine
              );
              AppCtrl.setCacheAccount(palyerAccount);
              AppCtrl.setCachePassword(playerPassword);
              AppCtrl.requestLobbies();
              const withAPIGame = Config?.withAPIGame ?? false;
              if (withAPIGame) {
                AppCtrl.requestAtgGames();
                AppCtrl.requestRsgGames();
              }
            });
          }

          //topUpRef.current.contentWindow.postMessage('receive', '*');

          break;
        case "REQUEST_KEYIN":
          {
            const keyInType = event.data.keyInType;
            const keyScore =
              keyInType === 1 ? playerKeyInScore1 : playerKeyInScore2;
            let keyInScoreSmall =
              playerKeyInScore1 < playerKeyInScore2
                ? playerKeyInScore1
                : playerKeyInScore2;
            //let keyInScoreBig = playerKeyInScore1 > playerKeyInScore2 ? playerKeyInScore1 : playerKeyInScore2;
            //keyInScoreSmall = keyInScoreSmall <= 0  ? 100 : keyInScoreSmall;
            let keyInScoreBase = keyScore / keyInScoreSmall;

            //let keyScoreBase = Math.min(playerKeyInScore1, playerKeyInScore2);
            const apiData = {
              gm: gmAccount,
              account: palyerAccount,
              coins: keyScore,
            };
            let srcWin = event.source;
            //const count = event.data.bill;
            const count = keyInScoreBase;
            AppCtrl.IncreaseUserCoins(apiData, function (resObj) {
              if (resObj.status == "success") {
                AppCtrl.getSourceWin().postMessage(
                  { type: "RESPONSE_KEYIN", Result: "SUCCESS", Count: count },
                  AppCtrl.getOriginDomain()
                );
                console.log("開分成功:", event.data.bill);
              } else {
                AppCtrl.getSourceWin().postMessage(
                  { type: "RESPONSE_KEYIN", Result: "FAIL", Count: count },
                  AppCtrl.getOriginDomain()
                );
                console.log("開分失敗:", event.data.bill);
              }
            });
            console.log("帳戶餘額更新:", event.data.bill);
          }
          break;
        case "REQUEST_KEYOUT":
          {
            playerKeyOutScore = playerKeyOutScore || 100;
            const userInfo = AppCtrl.userInfo();
            const coins = userInfo.InCoins - userInfo.OutCoins;
            const count = Math.floor(coins / playerKeyOutScore);
            const keyOut = count * playerKeyOutScore;
            if (coins < keyOut) {
              AppCtrl.getSourceWin().postMessage(
                {
                  type: "RESPONSE_KEYOUT",
                  Result: "FAIL",
                  Count: count,
                },
                AppCtrl.getOriginDomain()
              );
              console.log("洗分失敗:", keyOut);
              break;
            }

            const apiData = {
              gm: gmAccount,
              account: palyerAccount,
              coins: keyOut,
            };
            let srcWin = event.source;
            AppCtrl.SubtractUserCoins(apiData, function (resObj) {
              if (resObj.status == "success") {
                AppCtrl.getSourceWin().postMessage(
                  {
                    type: "RESPONSE_KEYOUT",
                    Result: "SUCCESS",
                    Count: count,
                  },
                  AppCtrl.getOriginDomain()
                );
                console.log("洗分成功:", coins);
              } else {
                AppCtrl.getSourceWin().postMessage(
                  {
                    type: "RESPONSE_KEYOUT",
                    Result: "FAIL",
                    Count: count,
                  },
                  AppCtrl.getOriginDomain()
                );
                console.log("洗分失敗:", keyOut);
              }
            });
            console.log("帳戶餘額更新:", keyOut);
          }
          break;
        case "REQUEST_BILL_ACCEPTOR":
          {
            const apiData = {
              gm: gmAccount,
              account: palyerAccount,
              coins: event.data.bill,
            };
            let srcWin = event.source;
            AppCtrl.IncreaseUserCoins(apiData, function (resObj) {
              if (resObj.status == "success") {
                AppCtrl.getSourceWin().postMessage(
                  { type: "RESPONSE_BILL_ACCEPTOR", Result: "SUCCESS" },
                  AppCtrl.getOriginDomain()
                );
                console.log("儲值成功:", event.data.bill);
              } else {
                AppCtrl.getSourceWin().postMessage(
                  { type: "RESPONSE_BILL_ACCEPTOR", Result: "FAIL" },
                  AppCtrl.getOriginDomain()
                );
                console.log("儲值失敗:", event.data.bill);
              }
            });
            console.log("帳戶餘額更新:", event.data.bill);
          }
          break;
        case "REQUEST_CREDIT_OUT":
          {
            const userInfo = AppCtrl.userInfo();
            const coins = userInfo.InCoins - userInfo.OutCoins;
            const apiData = {
              gm: gmAccount,
              account: palyerAccount,
              coins: coins,
            };
            let srcWin = event.source;
            AppCtrl.SubtractUserCoins(apiData, function (resObj) {
              if (resObj.status == "success") {
                AppCtrl.getSourceWin().postMessage(
                  {
                    type: "RESPONSE_CREDIT_OUT",
                    scores: coins,
                    Result: "SUCCESS",
                  },
                  AppCtrl.getOriginDomain()
                );
                console.log("洗分成功:", coins);
              } else {
                AppCtrl.getSourceWin().postMessage(
                  {
                    type: "RESPONSE_CREDIT_OUT",
                    scores: coins,
                    Result: "FAIL",
                  },
                  AppCtrl.getOriginDomain()
                );
                console.log("洗分失敗:", coins);
              }
            });
            console.log("帳戶餘額更新:", coins);
          }
          break;
        case "REQUEST_TOPUP":
          {
            const requestTopUpToGameCb = (isSuccess) => {
              AppCtrl.getSourceWin().postMessage(
                {
                  type: "RESPONSE_TOPUP",
                  Result: isSuccess ? "SUCCESS" : "FAIL",
                },
                AppCtrl.getOriginDomain()
              );
            };
            AppCtrl.requestTopUpToGame(requestTopUpToGameCb);
          }
          break;
        case "ERROR":
          console.error("錯誤訊息:", event.data.message);
          break;

        default:
          console.warn("未知的訊息類型:", event.data);
      }
    });
  }

  function onLoginResponseFromMachine(objRes) {
    // clear timeout
    if (hLoginTimeout) {
      clearTimeout(hLoginTimeout);
      hLoginTimeout = null;
    }

    const status = objRes.status;
    const language = AppCtrl.getLanguage();
    if (status == "success") {
      if (Config.fullScreenLockMachine === true) {
        Utils.enterFullScreen();
      }

      const checkOrientationInLobby = AppCtrl.CheckOrientationInLobby();
      if (checkOrientationInLobby) {
        AppCtrl.SetOrientationInLobby(ScreenOrientation.LandscapePrimary);
        AppCtrl.LandscapePortraitSetInLobby(ScreenOrientation.LandscapePrimary);
      }

      AppCtrl.setCacheAccount(palyerAccount);
      AppCtrl.setCachePassword(playerPassword);
      const { agent, token, appId, award } = objRes;
      if (token && token.length > 0) {
        let awardMsg = "";
        let arardTitle = "";
        switch (language) {
          case LANGUAGE_TYPE.zh_TW:
            if (award && award.value > 0) {
              arardTitle = "登入成功";
              awardMsg = "獎勵贈分: " + award.value + "\r\n已經加入您帳號。";
            }

            break;
          case LANGUAGE_TYPE.en_US:
          default:
            if (award && award.value > 0) {
              arardTitle = "Loging Success";
              awardMsg = "Award: " + award.value + "\r\n send to your account";
            }
            break;
        }
        if (arardTitle !== "" && awardMsg !== "") {
          showAlert({
            title: arardTitle,
            text: awardMsg,
            icon: "success",
            showConfirmButton: false,
            timer: 1350,
          });
        }

        AppCtrl.getUserScores();
        if (Config.logginnotice) {
          const logginnotice = Config.logginnotice.notice || "";
          if (logginnotice != "") {
            //showAlert({ title: logginnotice });
            showAlert({
              title: logginnotice,
              icon: "warning",
              showConfirmButton: true,
            });
          }
        }
        AppCtrl.SetNewLogin(true);
        AppCtrl.getUserInfo(function (obj) {
          AppCtrl.requestLobbies();
          // check if user isn't verified, switch to settingsPage
          const mainSettings = AppCtrl.mainSettings();

          const userInfo = AppCtrl.userInfo();
          if (
            !userInfo.AvatarInfo ||
            Object.keys(userInfo.AvatarInfo).length == 0
          ) {
            // manage cookie
            setCookie("name", palyerAccount);
            setCookie("password", playerPassword);
            setCookie("agreement", true);
            setCookie("remeberMe", true);
            // if user's phone not verified, route to settingsPage
            if (mainSettings.VerifyUserInfo && !userInfo.Verified) {
              setFunc(EFunction.verifyPhone);
              // navigate('/verify-phone');
              switch (language) {
                case LANGUAGE_TYPE.zh_TW:
                  showAlert({ title: "驗證帳號能享受更多遊戲權利。" });
                  break;
                case LANGUAGE_TYPE.en_US:
                default:
                  showAlert({ title: "Verify account to enjoy more benefit." });
                  break;
              }
            } else {
              // show winLobby for user to choose winLobbyManager
              setFunc(EFunction.winLobby);
              // navigate('/lobby');
            }
          } else {
            // show winLobby for avatar to choose winLobbyManager
            setFunc(EFunction.winLobby);
            // navigate('/lobby');
          }
          AppCtrl.getBonusBroadcast();
        });
      } else {
        countDownRefresh();
        showAlert({ title: "Invalid token", text: "無效的鏈結值" });
      }
    } else {
      const err = objRes.error;
      switch (err) {
        case "密碼與電話不可相同": {
          AppCtrl.setCacheAccount(palyerAccount);
          AppCtrl.setCachePassword(playerPassword);
          setFunc(EFunction.changePassword);
          // navigate('/change-password');
          // assign parameters

          switch (language) {
            case LANGUAGE_TYPE.zh_TW:
              showAlert({ title: "您的密碼與電話相同，請變更密碼。" });
              break;
            case LANGUAGE_TYPE.en_US:
            default:
              showAlert({ title: "PhoneNo. Can not be same as password" });
              break;
          }
          break;
        }
        case "禁止多重登入": {
          let title = "";
          let text = "";
          switch (language) {
            case LANGUAGE_TYPE.zh_TW:
              title = "重複登入";
              text = `是否登出前一個連線中的裝置？`;
              break;
            case LANGUAGE_TYPE.en_US:
            default:
              title = "multi-login";
              text = `logout previous device?`;
              break;
          }

          const confirmCb = () => {
            AppCtrl.requestLoginToken(
              palyerAccount,
              palyerAccount,
              true,
              onLoginResponseFromMachine
            );
          };

          break;
        }
        default: {
          showAlert({ title: err ? err : "unable to get login token" });
          break;
        }
      }
    }

    if (Config.urlBGImage) {
      if (Utils.isGifByExtension(Config.urlBGImage)) {
        document.body.style.backgroundImage = `url('${Config.urlBGImage}')`;
        document.body.style.backgroundSize = "auto 100%";
        document.body.style.backgroundRepeat = "no-repeat";
        document.body.style.backgroundPosition = "center center";
      } else {
        document.body.style.backgroundImage = `url('${Config.urlBGImage}')`;
        document.body.style.backgroundSize = "100% 100%";
      }
    }
  }

  function componentWillUnmount() {
    console.log("exit App");
  }

  function onPage(newPage) {
    setPage(newPage);
  }

  function onUserCoins(newUserCoins) {
    setUserCoins(newUserCoins);
  }

  function onGuoZhao(newGuoZhao) {
    setGuoZhao(newGuoZhao);
  }

  function onScoreMsg(newScoreMsg) {
    setScoreMsg(newScoreMsg);
  }

  function onLobbyInfos(newLobbies) {
    setLobbies(newLobbies);
  }

  function onLobbyMachines(newLobbyMachines) {
    setLobbyMachines(newLobbyMachines);
  }

  function onBroadcastMsgs(newBroadscats) {
    setBroadcasts(newBroadscats);
  }

  function onBonusBroadcast(newBonusBroadcast) {
    setBonusBroadcast(newBonusBroadcast);
  }

  function onGameplay(newGameplay) {
    setGameplay(newGameplay);
  }

  function onBetWinData(newBetWinData) {
    setBetWinData(newBetWinData);
  }
  function onBoosting(newBoosting) {
    setBoosting(newBoosting);
  }
  function onBonusState(newBonusState) {
    setBonusState(newBonusState);
  }
  function onAtgGames(newAtgGames) {
    setAtgGames(newAtgGames);
  }
  function onAtgGameUrl(newAtgGameUrl) {
    setAtgGameUrl(newAtgGameUrl);
  }
  function onRsgGames(newRsgGames) {
    setRsgGames(newRsgGames);
  }
  function onRsgGameUrl(newRsgGameUrl) {
    setRsgGameUrl(newRsgGameUrl);
  }

  // function onCloseModal()
  // {
  //     AppCtrl.closeModal();
  // }

  // function onModalOk()
  // {
  //     AppCtrl.onModalConfirm(true);
  // }

  // function onModalCancel()
  // {
  //     AppCtrl.onModalConfirm(false);
  // }

  function render() {
    const curPage = AppCtrl.curPage();
    console.log(`curPage: ${curPage}`);
    switch (curPage) {
      case EPage.main:
        return <MainPage />;
      case EPage.lobby:
        return <LobbyPage />;
      case EPage.playClassic:
        return <GamePlayClassic />;
      case EPage.playBJ:
        return <GamePlayBaija />;
      case EPage.spyClassic:
        return <GameSpyClassic />;
      case EPage.reload:
        return <ReloadPage />;
      case EPage.atgLobby:
        return <AtgLobby />;
      case EPage.atgGame:
        return <AtgGame />;
      case EPage.rsgLobby:
        return <RsgLobby />;
      case EPage.rsgGame:
        return <RsgGame />;
      default:
        return <div>no page matched</div>;
    }
  }

  return (
    <div>
      <div ref={topUpRef}></div>
      {
        render()
        //<iframe ref={topUpRef}></iframe>
        // <Routes>
        //     <Route index path='/*' element={ <MainPage /> } />
        //     <Route path='/LobbyPage' element={ <LobbyPage /> } />
        //     <Route path='/playClassic' element={ <GamePlayClassic /> } />
        //     <Route path='/playBJ' element={ <GamePlayBaccarat /> } />
        //     <Route path='/spyClassic' element={ <GameSpyClassic /> } />
        //     <Route path='/reload' element={ <ReloadPage /> } />
        //     <Route path="*" element={<Navigate to='/main' replace />} />
        // </Routes>
      }
      {/* <div id="myModal" className={styles.modal}>
                <div className={styles.modalPanel}>
                    <span id="modalClose" className={styles.close} onClick={onCloseModal}>&times;</span>
                    <div id="modalContent"></div>
                    <div id="modalBtns" style={{padding:"10px", display:"none"}}>
                        <button style={{float:"left", width:"48%", height:"40px", fontSize:"18px"}} onClick={onModalOk}>確認</button>
                        <button style={{float:"right", width:"48%", height:"40px", fontSize:"18px"}} onClick={onModalCancel}>取消</button>
                    </div>
                </div>
            </div> */}
    </div>
  );
}

export default App;
